import { message } from 'antd'
import { deleteTimesheetPosting } from '../../../HttpRequests/timesheetPostings'
import { getProps } from '../props'
import handleException from '../../../Core/Helpers/handleException'

export default () => async () => {

  const { id, onClose, didDelete } = getProps()

  try {

    await deleteTimesheetPosting({ id })

    message.success('Posting Deleted')

    onClose()

    if (didDelete) didDelete()

  } catch (error) {

    handleException(error)

  }

}
